import { ChangeDetectorRef, Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { WalletService } from '../../../../Service/wallet/wallet.service';
import { ToastService } from '../../../../Service/ToastService/toast.service';
import { ServiceProviderService } from '../../../../Service/Service-providers/service-provider.service';
declare var Razorpay: any;

@Component({
  selector: 'app-add-balance',
  templateUrl: './add-balance.component.html',
  styleUrls: ['./add-balance.component.scss']
})
export class AddBalanceComponent {
  @Input() distributorId!: any;
  @Input() calledFrom: string = '';
  @Input() userId: number | null = null;
  @Input() label: string = 'Upload file';

  @Output() close = new EventEmitter<void>();
  @Output() balanceUpdated = new EventEmitter<void>();
  @Output() fileUploaded = new EventEmitter<number>();
  @Output() fileRemoved = new EventEmitter<void>();

  display = true;
  attachmentId: number | null = null;
  fileSourceId: number = 9;

  selectedFile: File | null = null;
  fileSelected: boolean = false;
  fileStatus: string = 'No file chosen';
  previewSrc: any | null = null;
  isSubmitting = false;

  form!: FormGroup;

  constructor(
    private fb: FormBuilder,
    private api: WalletService,
    private toastr: ToastService,
    private apis: ServiceProviderService,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit() {
    this.setFileSourceId();
    this.initForm();
  }

  setFileSourceId() {
    this.fileSourceId = this.calledFrom === 'service-distributor-details' ? 6 : 9;
  }

  initForm() {
    this.form = this.fb.group({
      amount: [null, [Validators.required, Validators.min(1)]],
    });
  }

  closeDialog() {
    this.display = false;
    this.close.emit();
    document.body.style.overflow = 'auto';
  }

  onFileSelect(event: any) {
    const file = event.target.files[0];
    if (!file) return;

    this.selectedFile = file;
    this.fileStatus = file.name;
    this.fileSelected = true;

    const formData = new FormData();
    formData.append('file', file);
    formData.append('description', this.label);
    formData.append('fileSourceId', this.fileSourceId.toString());
    formData.append('isPublic', 'true');

    this.apis.createFiles(formData).subscribe({
      next: (res: any) => {
        if (res.filePath) {
          this.previewSrc = res.filePath;
          this.attachmentId = res.fileId;
          this.fileUploaded.emit(res.fileId);
          this.cdr.detectChanges();
        }
      },
      error: () => {
        this.toastr.showToast('File upload failed.', 'error');
      }
    });
  }

  clearFileSelection() {
    if (this.previewSrc) {
      this.apis.deleteFile(this.previewSrc).subscribe();
    }

    this.fileStatus = 'No file chosen';
    this.previewSrc = null;
    this.fileSelected = false;
    this.selectedFile = null;
    this.attachmentId = null;
    this.fileRemoved.emit();
  }

  addBalance() {
    if (this.isSubmitting) return;

    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }


    this.isSubmitting = true; // LOCK SUBMISSION

    const { amount } = this.form.value;

    const commonPayload: any = {
      amount
    };

    switch (this.calledFrom) {
      case 'service-distributor-details':
        const distributorPayload = {
          ...commonPayload,
          distributorId: Number(this.distributorId)
        };


        this.api.topUpDistributorBalance(distributorPayload).subscribe({
          next: (res) => {
            this.handleApiResponse(res, 'Balance added successfully!');
            this.isSubmitting = false;
          },
          error: () => {
            this.toastr.showToast('Failed to add balance.', 'error');
            this.isSubmitting = false;
          }
        });
        break;

      case 'wallet-component':
        const userPayload = {
          ...commonPayload,
          userId: this.userId
        };


        this.initiateRazorpayPayment(userPayload);
        this.isSubmitting = false;
        break;

      case 'distributor-wallet-component':
        const selfPayload = {
          ...commonPayload,
          userId: this.userId
        };

        this.api.topUpSelf(selfPayload).subscribe({
          next: (res) => {
            this.handleApiResponse(res, 'Balance added successfully!');
            this.isSubmitting = false;
          },
          error: () => {
            this.toastr.showToast('Failed to add balance.', 'error');
            this.isSubmitting = false;
          }
        });
        break;

      default:
        this.toastr.showToast('Unknown balance source.', 'error');
        this.isSubmitting = false;
        break;
    }
  }


  handleApiResponse(res: any, successMessage: string) {
    if (res.isSuccess) {
      this.balanceUpdated.emit();
      this.toastr.showToast(successMessage, 'success');
      this.closeDialog();
    } else {
      this.toastr.showToast(res.errors[0], 'error');
    }
  }

  isImageFile(): boolean {
    return this.previewSrc?.toLowerCase().match(/\.(jpg|jpeg|png|gif)$/) ? true : false;
  }

  isPdfFile(): boolean {
    return this.previewSrc?.toLowerCase().endsWith('.pdf') || false;
  }

  callTopupSelfAPI(payload: any) {
    this.api.topUpSelf(payload).subscribe({
      next: () => {
        this.balanceUpdated.emit();
        this.toastr.showToast('Balance added successfully!', 'success');
        this.closeDialog();
      },
      error: () => {
        this.toastr.showToast('Failed to add balance.', 'error');
      }
    });
  }
  initiateRazorpayPayment(payload: any) {
    const user: any = JSON.parse(localStorage.getItem('user') || '{}');
    const fullName = user.firstName || 'Unknown';
    const contact = user.phoneNumber || '';

    console.log('Payload to create order:', payload);

    this.apis.createOrder(payload.amount, contact).subscribe({
      next: (orderResponse: any) => {
        console.log('Order API response:', orderResponse);

        if (!orderResponse?.isSuccess || !orderResponse.result?.id) {
          console.error('Invalid order response structure', orderResponse);
          this.toastr.showToast('Failed to create order. Try again.', 'error');
          return;
        }

        const razorpayOptions: any = {
          key: 'rzp_test_aLY35P49OeTQNl',
          amount: payload.amount * 100,
          currency: 'INR',
          name: 'Auto ECare',
          description: 'Wallet Top-Up',
          order_id: orderResponse.result.id,
          handler: (response: any) => {
            console.log('Payment success handler');
            console.log('Razorpay Payment ID:', response.razorpay_payment_id);
            console.log('Razorpay Order ID:', response.razorpay_order_id);
            this.verifyRazorPay(response.razorpay_payment_id);
          },
          prefill: {
            name: fullName,
            contact: contact
          },
          theme: {
            color: '#3399cc'
          }
        };

        console.log('Opening Razorpay with options:', razorpayOptions);

        const rzp = new Razorpay(razorpayOptions);
        rzp.open();
      },
      error: (err) => {
        console.error('Order creation failed:', err);
        this.toastr.showToast('Payment initiation failed.', 'error');
      }
    });
  }
  verifyRazorPay(paymentId: any) {
    const payload = {
      "paymentId": paymentId
    }
    this.api.verifyRazorPay(payload).subscribe({
      next: (res: any) => {
        if (res.isSuccess && res.result) {
          console.log(res)
          this.balanceUpdated.emit();
          this.toastr.showToast('Balance added successfully!', 'success');
          this.closeDialog();
        } else {
          console.log(res)
        }
      }
    })
  }

  // verifyAndTopUp(paymentId: string, payload: any) {
  //   this.apis.verifyPayment(paymentId).subscribe({
  //     next: (res: any) => {
  //       if (res.isSuccess && res.result.status === 'captured') {
  //         this.toastr.showToast('Payment verified successfully', 'success');
  //         this.callTopupSelfAPI(payload);
  //       } else {
  //         this.toastr.showToast('Payment verification failed.', 'error');
  //       }
  //     },
  //     error: () => {
  //       this.toastr.showToast('Payment verification failed.', 'error');
  //     }
  //   });
  // }


}
